import { render, staticRenderFns } from "./programTrans.vue?vue&type=template&id=65e07f28"
import script from "./programTrans.vue?vue&type=script&lang=js"
export * from "./programTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports